import Toast from '@/utils/toast'
export const activity = {
  state: {
    activityDetail: {}
  },
  getters: {},
  mutations: {
    SET_ACTIVITY_DETAIL(state,item)  {
      state.activityDetail = item
    }
  },
  actions: {
    setActivityDetail({commit},item)  {
      commit('SET_ACTIVITY_DETAIL',item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js